import { fadeToggleButtons } from "./animations";

export function destroyUserHandler() {
  document.querySelectorAll("#deleteuser, #ohno").forEach((button) => {
    button.addEventListener("click", fadeToggleButtons);
  });
}
